import type { AccountEnvironment } from "@keycloak/keycloak-account-ui";
import { getInjectedEnvironment } from "@keycloak/keycloak-ui-shared";

export const environment = getInjectedEnvironment<AccountEnvironment>();

export type Features = AccountEnvironment["features"];
